/*
 * <extend-product-offer>: the Extend protection offer in the PDP buy box.
 * Markup: snippets/extend-product-offer.liquid (rendered by sections/main-product.liquid, above the purchase row and
 * outside the product form, which it finds through data-form).
 * Depends on assets/extend-integration.js (SDK config) and the PUB_SUB_EVENTS.variantChange event.
 *
 * Behaviour matches the live theme: the offer renders for the selected variant and follows variant changes, and a
 * capture-phase click on Add to Cart opens Extend's modal first, then re-clicks the button once Extend is done so
 * Dawn's own add-to-cart (assets/product-form.js) adds the product.
 *
 * It is a custom element (not a one-off script) so it re-initialises when Dawn swaps the whole <product-info> node.
 */
if (!customElements.get('extend-product-offer')) {
  customElements.define(
    'extend-product-offer',
    class ExtendProductOffer extends HTMLElement {
      connectedCallback() {
        const integration = window.Extend?.integration;
        if (!integration?.enabled || !window.ExtendShopify) return;
        // The quick-add modal reuses the product form on collection pages; the offer is product-page only.
        if (this.closest('quick-add-modal')) return;

        this.form = document.getElementById(this.dataset.form);
        this.addButton = this.form?.querySelector('[type="submit"][name="add"]');
        if (!this.form || !this.addButton) return;

        this.category = this.dataset.productType;
        this.skipOffer = false;

        this.offer?.remove();
        this.offer = document.createElement('div');
        this.offer.className = 'extend-offer';
        this.append(this.offer);

        window.Extend.buttons.render(this.offer, {
          referenceId: this.dataset.variantId,
          price: parseInt(this.dataset.price),
          category: this.category,
        });

        this.addButton.addEventListener('click', this.onAddToCartClick, true);
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange);
      }

      disconnectedCallback() {
        this.addButton?.removeEventListener('click', this.onAddToCartClick, true);
        this.variantChangeUnsubscriber?.();
      }

      onVariantChange = ({ data }) => {
        if (data.sectionId !== this.dataset.section || !data.variant) return;

        window.Extend.setActiveProduct(this.offer, {
          referenceId: data.variant.id.toString(),
          price: parseInt(data.variant.price),
          category: this.category,
        });
      };

      onAddToCartClick = (event) => {
        // Let our own re-click, and clicks Dawn is already handling (aria-disabled while adding), straight through.
        if (this.skipOffer || this.addButton.getAttribute('aria-disabled') === 'true') return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const variantId = this.form.elements.id?.value;
        const quantity = this.form.elements.quantity?.value;

        window.ExtendShopify.handleAddToCart(this.offer, {
          quantity,
          modal: true,
          done: () => {
            window.Extend.integration.productAnalytics?.(variantId, quantity);

            this.skipOffer = true;
            this.addButton.click();
            this.skipOffer = false;
          },
        });
      };
    },
  );
}
